import { RouteObject } from 'react-router-dom';
import { FeatureSliderManager } from './employers-managment/feature-slider-manager';

export const ADMIN_ROUTES: RouteObject[] = [
   {
      path: '/admin/users/selectforslider',
      Component: FeatureSliderManager,
   },
];
